import { Button, Stack, ThumbUpIcon, ThumbUpOutlinedIcon, ReplyIcon, ExpandMoreIcon, ExpandLessIcon } from 'src/components';
import CommentMenu from './comment-menu';

export default function CommentActions({
    isAuthor,
    hasUpvoted,
    isMobile,
    replies,
    repliesCollapsed,
    onToggleReplyForm,
    onToggleReplies,
    onToggleUpvote,
    onEdit,
    onDelete,
    upvoteCount
}) {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{ mt: 1 }}
        >
            {/* Left-aligned actions */}
            <Stack direction="row" spacing={1} alignItems="center">
                <Button
                    size="small"
                    variant="text"
                    disabled={isAuthor}
                    disableRipple
                    color="inherit"
                    startIcon={<ReplyIcon sx={{ fontSize: 14 }} />}
                    onClick={onToggleReplyForm}
                    sx={{
                        minWidth: 'auto',
                        px: 1,
                        py: 0.5,
                        fontSize: isMobile ? 12 : 11,
                        textTransform: 'none',
                        color: 'text.secondary',
                        '&:hover': {
                            bgcolor: 'transparent',
                            color: 'primary.main',
                        },
                    }}
                >
                    Reply
                </Button>

                {replies.length > 0 && (
                    <Button
                        size="small"
                        disableRipple
                        variant="text"
                        color="inherit"
                        startIcon={repliesCollapsed ? <ExpandMoreIcon sx={{ fontSize: 14 }} /> : <ExpandLessIcon sx={{ fontSize: 14 }} />}
                        onClick={onToggleReplies}
                        sx={{
                            minWidth: 'auto',
                            px: 1,
                            py: 0.5,
                            fontSize: isMobile ? 12 : 11,
                            textTransform: 'none',
                            color: 'text.secondary',
                            '&:hover': {
                                bgcolor: 'transparent',
                                color: 'primary.main',
                            },
                        }}
                    >
                        {repliesCollapsed ? 'Show' : 'Hide'} replies
                    </Button>
                )}

                <Button
                    size="small"
                    disabled={isAuthor}
                    disableRipple
                    startIcon={hasUpvoted ? <ThumbUpIcon fontSize="small" /> : <ThumbUpOutlinedIcon fontSize="small" />}
                    onClick={onToggleUpvote}
                    sx={{
                        color: 'text.secondary',
                        '&:hover': {
                            bgcolor: 'transparent',
                            color: 'primary.main',
                        },
                    }}
                >
                    {upvoteCount}
                </Button>
            </Stack>

            {/* Right-aligned actions */}
            {isAuthor && (
                <CommentMenu onEdit={onEdit} onDelete={onDelete} />
            )}
        </Stack>
    );
}
